// @ts-ignore
// @ts-nocheck
import moment from 'moment';

export function getComplementRefuel(
  status,
  noVisitCode = null,
  noSupplyCode = null,
  forecastDate = null,
  deliveryDate = null,
  reprogrammingDate = null,
  caseNumber = null,
  orderNumber = null
) {
  const msgcadastro =
    'Identificamos uma irregularidade em seu cadastro como cliente Ultragaz, entre contato com seu consultor para regularizar a situação.';
  const msgRecusa = `Houve recusa no recebimento do abastecimento e isso pode causar falta de gás.
                Para solicitar novo abastecimento, acesse o menu de “Novo Pedido” no Portal.`;
  const msgIrregularidade = `Identificamos uma irregularidade na sua central. Para regularização solicite uma visita técnica no portal Minha Ultragaz, menu “Manutenção”.`;

  if (!orderNumber && caseNumber)
    return `Seu pedido está em análise (Protocolo: ${caseNumber})`;

  if (status === 'EM_ANALISE')
    return 'Pedido está em análise e poderá sofrer alterações';
  if (status === 'CONFIRMADO') return 'Pedido foi confirmado';
  if (status === 'EM_ROTA') return 'O motorista está a caminho';
  if (status === 'AGENDADO' && forecastDate)
    return `Pedido foi agendado para ${moment(forecastDate).format(
      'DD/MM/YY'
    )}`;
  if (status === 'ATENDIDO' && deliveryDate !== null)
    return `Pedido entregue em ${moment(deliveryDate).format('DD/MM/YY')}`;
  if (status === 'REPROGRAMADO' && reprogrammingDate)
    return `Pedido reprogramado para ${moment(reprogrammingDate).format(
      'DD/MM/YY'
    )}`;

  if (status === 'NAO_ATENDIDO' && noVisitCode) {
    switch (noVisitCode) {
      case 10:
      case 11:
      case 8:
        return msgcadastro;
      case 5:
      case 19:
      case 20:
      case 21:
      case 22:
      case 23:
        return msgRecusa;
      case 31:
        return msgIrregularidade;
      default:
        return '';
    }
  }

  if (status === 'NAO_ATENDIDO' && noSupplyCode) {
    switch (noSupplyCode) {
      case 7:
      case 33:
        return msgcadastro;
      case 5:
      case 15:
      case 16:
      case 21:
      case 23:
      case 24:
      case 25:
      case 26:
      case 27:
      case 28:
      case 29:
      case 31:
      case 32:
        return msgRecusa;
      case 6:
      case 14:
      case 36:
        return msgIrregularidade;
      default:
        return '';
    }
  }
  return null;
}
